//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React, { Component, useRef } from 'react';

///////////////////////////////////////////////////////////   Peakmeter

import { WebAudioPeakMeter } from 'web-audio-peak-meter';

class PeakMeter extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.audioCtx = new AudioContext();
    }
    peakerObject: {} | any = {};
    audioCtx: any;
    sourceNode: any;
    videoElement: any;
    meterElement: any;
    gain: any;



    componentDidMount() {
        this.Init();
    }


    componentDidUpdate(prevProps: any, prevState: any) {
        if (this.props.show === true) {
            if (this.props.play === true) {
                this.audioCtx.resume();
            }
            else {
                this.audioCtx.resume();
            }
        }
        this.audioCtx.resume();
    }



    public Init = () => {

        this.gain = this.audioCtx.createGain();
        const options = {
            vertical: true,
            gradient: ['red 1%', 'red 19%', 'yellow 19%', 'yellow 38%', '#080 38%', '#080 100%'],
            dbTickSize: 9,
            peakHoldDuration: 2000,
        }

        this.videoElement = document.getElementById("the-video_html5_api") as HTMLMediaElement;

        this.meterElement = document.getElementById('peak-meter')!;
        this.sourceNode = this.audioCtx.createMediaElementSource(this.videoElement);

        this.sourceNode.connect(this.audioCtx.destination);



        this.peakerObject = new WebAudioPeakMeter(this.sourceNode, this.meterElement, options);
        this.audioCtx.resume()
    };

    ///////////////////////////////////////////////////////////   RENDER
    render() {
        return (
            <>
                <div className={this.props.show ? "d-flex peak-container" : "d-none peak-container"}>
                    <div id="peak-meter" ></div>
                </div>
            </>
        )
    }
}
export default PeakMeter;
